(() => {
	const dropdowns = document.querySelectorAll('.cc-dropdown');

	const toggleList = dropdown => {
		const list = dropdown.querySelector('.cc-dropdown__list');
		const activeClass = 'cc-dropdown__list--active';
		if(list.classList.contains(activeClass)) {
			list.classList.remove(activeClass);
		} else {
			list.classList.add(activeClass);
		}
	};

	const setActive = (dropdown, item, init = false) => {
		const target = dropdown.querySelector('.cc-dropdown__toggle-content');
		const options = dropdown.querySelectorAll('.cc-dropdown__list-item');
		const value = item.dataset.value;
		const action = item.dataset.action;

		options.forEach(o => {
			o.classList.remove('cc-dropdown__list-item--selected');
		});

		item.classList.add('cc-dropdown__list-item--selected');

		if(action && !init) {
			window.location.href = action;
		}

		if(value) {
			target.innerText = value;
		}

		if(!init) {
			toggleList(dropdown);
		}
	};

	dropdowns.forEach(dropdown => {
		const toggle = dropdown.querySelector('.cc-dropdown__toggle');
		const list = dropdown.querySelector('.cc-dropdown__list');
		const options = dropdown.querySelectorAll('.cc-dropdown__list-item');
		const selectedItem = list.querySelector('.cc-dropdown__list-item--selected');

		if(selectedItem) {
			setActive(dropdown, selectedItem, true);
		}

		toggle.addEventListener('click', e => {
			e.preventDefault();
			toggleList(dropdown);
		});
		
		options.forEach(option => {
			option.addEventListener('click', e => {
				e.preventDefault();
				setActive(dropdown, option);
			});
		});
	});

})();